import {
    RESET_WALLPAPER_COLOR,
    SET_WALLPAPER_COLOR,
    SET_WALLPAPER_PREVIEW_COLOR,
    WALLPAPER_PREVIEW_SECTION,
} from '../Actions/Constants';
import { WALLPAPER_DEFAULT_COLOR } from '../Helpers/Constants';

const initialState = {
    color: WALLPAPER_DEFAULT_COLOR,
    previewColor: WALLPAPER_DEFAULT_COLOR,
    previewSection: false,
};

const WallpaperReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_WALLPAPER_COLOR:
            return {
                ...state,
                color: action.payload.color,
            };

        case RESET_WALLPAPER_COLOR:
            return {
                ...state,
                color: WALLPAPER_DEFAULT_COLOR,
            };

        case WALLPAPER_PREVIEW_SECTION:
            return {
                ...state,
                previewSection: action.payload.previewSection,
            };

        case SET_WALLPAPER_PREVIEW_COLOR:
            return {
                ...state,
                previewColor: action.payload.previewColor,
            };

        default:
            return state;
    }
};

export default WallpaperReducer;
